module.exports = __webpack_public_path__ + "static/media/huobi.75bc2b37.svg";